import React from 'react'
import './projects.css'

const Projects = () => {
  return (
    <div>Projects</div>
  )
}

export default Projects